// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2556":"ee2a65b2","2762":"e459f764","5018":"e459f764"}[chunkId] + ".chunk.css";
};